import { useSplitEnabled } from '@buffer-mono/features'

import { NewSettingsPageLayout } from './components/NewSettingsPageLayout'
import CreatedAt from './OrganizationSettings/CreatedAt'
import OrganizationName from './OrganizationSettings/OrganizationName'
import TransferOwner from './OrganizationSettings/TransferOwner'

const GeneralSettings = (): JSX.Element => {
  const { isEnabled: isTransferOrgOwnershipEnabled } = useSplitEnabled(
    'transfer-org-ownership',
  )

  return (
    <NewSettingsPageLayout title="General" gap="md">
      <CreatedAt />
      <OrganizationName />
      {isTransferOrgOwnershipEnabled && <TransferOwner />}
    </NewSettingsPageLayout>
  )
}

export default GeneralSettings
